import Vue from 'vue'
import Vuex from 'vuex'

import comments from './modules/comments.js'
import errorDialog from './modules/errorDialog.js'
import users from './modules/users.js'
import pageState from './modules/pageState.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    comments,
    errorDialog,
    pageState,
    users
  }
})
